const modalContainer = document.querySelector(".tangent-modal-overlay");
const modalClosebtn = document.querySelector(".modal-close-btn");
const productBlock = document.querySelector(".product-block");
const quizContainer = document.querySelector("#tangent-main-container");
const productContainer = document.querySelector(".product-recommendation-container");

modalClosebtn.addEventListener("click", () => {
    handleModalClose();
});

const handleModalClose =()=>{
  modalContainer.style.display = "none";
}

// const handleRetakeQuiz=()=>{
//   productContainer.style.display = "none";
//   quizContainer.style.display = "block";
// }

window.addEventListener("quiz_submit", (e) => {
    TangentAi.init(e.detail)
});

const TangentAi = function () {

    const init = (resp_id) => {
        fetchRecommendation(resp_id).then(recommendationData => displayRecommendation(recommendationData)).catch(e => console.log(e))
    }

    const fetchRecommendation = async (resp_id) => {
        try {
            let response = await fetch(
                `https://service.tangent.ai/shopify/get-checkout-products?resp_id=${resp_id}&self_serve=true&multiple_variants=true`
            );
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            let globalData = await response.json();
            return globalData;
        } catch (error) {
            console.error("Error fetching data:", error);
            return null;
        }
    }

    const renderProducts = (products) => {
      const productHtml = `
          <img class="product-image" src="${products[0].variantImage}"/>
          <p class="product-title">${products[0].title} - ${products[0].variantTitle}</p>
          <button class="product-add-to-cart-button" id='${products[0].variantId}' onclick='handleModalClose()' >Close</button>
      `
      productBlock.innerHTML = productHtml;
    }

    const displayRecommendation = (data) => {
        let recommendedProducts = getRecommendedProductDetails(data.selected_variants, data.products)
        console.log(recommendedProducts, "recommend product")
        quizContainer.style.display="none";  
        productContainer.style.display="block"
        renderProducts(recommendedProducts);
    }

        //add variant/product to cart
    const addVariantToCart = (variantId) => {
        console.log(variantId, "variant id")
        let formData = {
          "items": [{"id": variantId, "quantity": 1, "selling_plan": "4788715746"}]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        }).then((res) => {
            let addToCartBtn = document.querySelector(".product-add-to-cart-button");
            addToCartBtn.innerText = "Added to cart";
            // addToCartBtn.id = "added-to-cart";
            addToCartBtn.setAttribute("disabled", true);
            // postCartEvent(variant_ids);
            console.log(res, "response cart")
        }).catch((error) => {
            console.error('Error:', error);
        });
    }
    
    //get the filtered variants from the section
    const getSelectedVariantsObject = (individualProducts, selectedVaraints) => {
        const filteredObject = {};

        // Iterate through the array of individual product IDs
        individualProducts.forEach(productId => {
            // Check if the product ID exists in the second object
            if (selectedVaraints.hasOwnProperty(productId)) {
                // Add the product ID and its variants to the filtered object
                filteredObject[productId] = selectedVaraints[productId];
            }
        });

        return filteredObject;
    }

    //get all the recommended products' details for UI
    const getRecommendedProductDetails = (selectedVariants, productList) => {
        let resultedProducts = []
        // Map through selected variants and match them with products
        for (let productId in selectedVariants) {
            if (selectedVariants[productId].length > 0) {
                let matchingProduct = filterList(productList, productId) //get matching product
                console.log(matchingProduct, "matching product")
                if (matchingProduct) {
                    for (let variantId of selectedVariants[productId]) {
                        let matchingVariant = filterList(matchingProduct.variants, variantId) //get matching variant
                        if (matchingVariant) {
                            let productDetails = {
                                title: matchingProduct.title,
                                handle: matchingProduct.handle,
                                productId: matchingProduct.id,
                                variantId: matchingVariant.id,
                                variantTitle: matchingVariant.title,
                                variantImage: getVariantImage(matchingVariant.image_id, matchingProduct),
                                price: matchingVariant.price,
                                isVariantAvailable: isVariantAvalaible(matchingProduct, matchingVariant),
                                imageAlt: "Variant image"
                            };
                            resultedProducts.push(productDetails);
                        }
                    }
                }
            }
        }
        return resultedProducts;
    }

    //get the single item from an array with a matching id
    const filterList = (lists, matchingId) => {
        console.log(lists, "lists", matchingId, "matchingId")
        return lists.find((list) => {
            const id = list.id || list.node?.id.split("/").pop();
            return id == matchingId
        })
    }

    //check variant availability
    const isVariantAvalaible = (product, variant) => {
        if (product.status == "ARCHIVED") {
            return false;
        } else {
            return (variant.inventoryQuantity > 0 || variant.inventory_policy.toLowerCase() === "continue");
        }
    }

    //get variant image
    const getVariantImage = (imageId, product) => {
        if (imageId) {
            return product.images.find((image) => image.id == imageId).src;
        }
        return "";
    }

    return {
        init,
        addVariantToCart
    }
}();
